import React, { FC } from 'react';
import { nullSafeGet } from '../../utils/DataAccessUtils';
import { Card, Col, Row } from 'antd';
import { FlexibleImageAvatar } from '../flexible-image-avatar/FlexibleImageAvatar';
import { AddressDisplay } from '../address_display/AddressDisplay';
import { checkAndFormatPhoneNumber } from '../../utils/DataFormatterUtils';
import { getContractorWO } from '../../utils/WorkOrderUtils';

require('./SubContractorCardDisplay.less');

const SubContractorCardDisplay: FC<any> = ({ workOrder, isClientView }): React.ReactElement => {
	const contractorWO = getContractorWO(workOrder, isClientView);

	const facilityDetail = isClientView
		? nullSafeGet('contractorSupplierFacility', contractorWO)
		: nullSafeGet('subSupplierFacility', contractorWO);

	const phoneNumbers = Array.from(
		new Set(
			[
				...(nullSafeGet('primaryPhone', facilityDetail)
					? [nullSafeGet('primaryPhone', facilityDetail)]
					: []),
			].map((num) => checkAndFormatPhoneNumber(num))
		)
	);
	const emails = Array.from(
		new Set([
			...(nullSafeGet('primaryContactEmail', facilityDetail)
				? [nullSafeGet('primaryContactEmail', facilityDetail)]
				: []),
		])
	);
	return (
		<div>
			<Card title={isClientView ? 'Contractor' : 'Subcontractor'} hoverable={true}>
				<div className="materialCard__flexCentVert" style={{ marginBottom: 24 }}>
					<div style={{ marginRight: 16 }}>
						{nullSafeGet('subContractedToWorkOrder.subSupplierFacility.logoURL', workOrder) ? (
							<FlexibleImageAvatar
								displayName={nullSafeGet('displayName', facilityDetail)}
								showPopover={false}
								popoverText={nullSafeGet('displayName', facilityDetail)}
								squareMode={true}
								width="40px"
								height="40px"
								imageUrl={nullSafeGet('logoURL', facilityDetail)}
							/>
						) : (
							<FlexibleImageAvatar
								displayName={nullSafeGet('displayName', facilityDetail)}
								showPopover={false}
								popoverText={nullSafeGet('displayName', facilityDetail)}
								squareMode={true}
								width="40px"
								height="40px"
								imageUrl="https://s3.amazonaws.com/emptor-data-assets/images/empty-state/icons8-city-filled-100.png"
							/>
						)}
					</div>
					<div>
						<div className="materialCard__title">{nullSafeGet('displayName', facilityDetail)}</div>
						<AddressDisplay
							className="materialCard__subtitle"
							hidePostcode={true}
							hideCountry={true}
							hideStreetAddress={true}
							address={nullSafeGet('primaryAddress', facilityDetail)}
							style={{
								color: 'rgba(0,0,0,0.45)',
							}}
						/>
					</div>
				</div>
				<div
					className="materialCard__supportingText materialCard__flexCentVert"
					style={{ marginTop: 16, marginBottom: 8 }}
				>
					<div className="materialCard__iconLabel">
						<i style={{ fontSize: 24 }} className={`icons8-font icons8-phone`} />
					</div>
					<div style={{ display: 'flex', whiteSpace: 'normal', flexWrap: 'wrap' }}>
						{phoneNumbers.map((num, i, list) => (
							<div style={{ marginRight: 4 }}>
								{checkAndFormatPhoneNumber(num)}
								{list.length - 1 > i ? ',' : null}
							</div>
						))}
					</div>
				</div>
				{nullSafeGet('primaryContactEmail', facilityDetail) ? (
					<div
						className="materialCard__supportingText materialCard__flexCentVert"
						style={{ marginBottom: 8 }}
					>
						<div className="materialCard__iconLabel">
							<i style={{ fontSize: 24 }} className={`icons8-font icons8-secured-letter-filled`} />
						</div>
						<Col>
							{emails.map((email) => (
								<Row wrap>{email}</Row>
							))}
						</Col>
					</div>
				) : null}
			</Card>
		</div>
	);
};

export default SubContractorCardDisplay;
